// const SMARTPHONE_API_SLUG = 'smartphoneapi/SE_InteractiveServices_Staging';
// const HPSBRIDGE_SLUG = 'hpsbridge/hpsbridge_staging';
// const DIGITALHPS_SLUG = 'hpsbridge/digitaltps_staging';
// const OFFERS_API_SLUG = 'smartphoneapi/offers_staging';

// const SMARTPHONE_API_SLUG = 'smartphoneapi/SE_InteractiveServices';
// const HPSBRIDGE_SLUG = 'hpsbridge/hpsbridge_beta';
// const DIGITALHPS_SLUG = 'hpsbridge/digitaltps_beta';
// const OFFERS_API_SLUG = 'smartphoneapi/offersV1';

const SMARTPHONE_API_SLUG = 'smartphoneapi/SE_InteractiveServices';
const HPSBRIDGE_SLUG = 'hpsbridge';
const DIGITALHPS_SLUG = 'hpsbridge/digitaltps';
const OFFERS_API_SLUG = 'smartphoneapi/OffersV1';

export default {
    SMARTPHONE_API_SLUG,
    HPSBRIDGE_SLUG,
    DIGITALHPS_SLUG,
    OFFERS_API_SLUG
}
    
